import type { User, CreateUserRequest } from '../entities/User';
import type { Result } from '../../shared/types/common.types';

export interface IUserDomainService {
  validateUserEmail(email: string): Result<void>;
  validateUserData(userData: CreateUserRequest): Result<void>;
  canUserBeActivated(user: User): boolean;
  isUserEmailUnique(email: string, existingUsers: User[]): boolean;
}

export class UserDomainService implements IUserDomainService {
  validateUserEmail(email: string): Result<void> {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return { success: false, error: new Error('Invalid email format') };
    }
    return { success: true, data: undefined };
  }

  validateUserData(userData: CreateUserRequest): Result<void> {
    if (!userData.email || !userData.firstName || !userData.lastName || !userData.password) {
      return { success: false, error: new Error('All fields are required') };
    }

    if (userData.password.length < 8) {
      return { success: false, error: new Error('Password must be at least 8 characters') };
    }

    const emailValidation = this.validateUserEmail(userData.email);
    if (!emailValidation.success) {
      return emailValidation;
    }

    return { success: true, data: undefined };
  }

  canUserBeActivated(user: User): boolean {
    return user.email.length > 0 && user.firstName.length > 0 && user.lastName.length > 0;
  }

  isUserEmailUnique(email: string, existingUsers: User[]): boolean {
    return !existingUsers.some(user => user.email === email);
  }
}
